import { IconType } from 'react-icons';
import {
	FaFile,
	FaFileCsv,
	FaFileExcel,
	FaFileImage,
	FaFilePdf,
	FaFilePowerpoint,
	FaFileWord,
} from 'react-icons/fa6';

export const units = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

export const thumbCategoryIcons: Record<string, IconType> = {
	image: FaFileImage,
	pdf: FaFilePdf,
	csv: FaFileCsv,
	text: FaFileWord,
	spreadsheet: FaFileExcel,
	presentation: FaFilePowerpoint,
	default: FaFile,
};

export const extensionToCategory: Record<
	string,
	keyof typeof thumbCategoryIcons
> = {
	'image/jpeg': 'image',
	'image/png': 'image',
	'application/pdf': 'pdf',
	'text/csv': 'csv',
	'application/msword': 'text',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
		'text',
	'application/vnd.ms-excel': 'spreadsheet',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
		'spreadsheet',
	'application/vnd.ms-powerpoint': 'presentation',
	'application/vnd.openxmlformats-officedocument.presentationml.presentation':
		'presentation',
};
